import { render, staticRenderFns } from "./beijing.vue?vue&type=template&id=5bd3eb60&scoped=true&"
import script from "./beijing.vue?vue&type=script&lang=js&"
export * from "./beijing.vue?vue&type=script&lang=js&"
import style0 from "./beijing.vue?vue&type=style&index=0&id=5bd3eb60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd3eb60",
  null
  
)

export default component.exports